// extracted by mini-css-extract-plugin
module.exports = {"container":"uU-z","recos":"vU-z","productCardOverride":"wU-z"};